import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix, useIsRTL } from './ThemeProvider';
import PopoverHeader from './PopoverHeader';
import PopoverBody from './PopoverBody';
import { getOverlayDirection } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultProps = {
  placement: 'right'
};
var Popover = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    placement = _ref.placement,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    body = _ref.body,
    arrowProps = _ref.arrowProps,
    _ = _ref.popper,
    _1 = _ref.show,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "placement", "className", "style", "children", "body", "arrowProps", "popper", "show"]);
  var decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'popover');
  var isRTL = useIsRTL();
  var _ref2 = (placement == null ? void 0 : placement.split('-')) || [],
    _ref3 = _slicedToArray(_ref2, 1),
    primaryPlacement = _ref3[0];
  var bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  return /*#__PURE__*/_jsxs("div", _objectSpread({
    ref: ref,
    role: "tooltip",
    style: style,
    "x-placement": primaryPlacement,
    className: classNames(className, decoratedBsPrefix, primaryPlacement && "bs-popover-".concat(bsDirection))
  }, props, {
    children: [/*#__PURE__*/_jsx("div", _objectSpread({
      className: "popover-arrow"
    }, arrowProps)), body ? /*#__PURE__*/_jsx(PopoverBody, {
      children: children
    }) : children]
  }));
});
Popover.defaultProps = defaultProps;
export default Object.assign(Popover, {
  Header: PopoverHeader,
  Body: PopoverBody,
  // Default popover offset.
  // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
  POPPER_OFFSET: [0, 8]
});